import React, {PureComponent} from 'react';
import PulsingDot from './pulsingDot';
import PulsingStrike from './pulsingStrike';
import { NonPulsingStrike } from './nonPulsingStrike';

// const colors = ['#fb8072','#8aff87','#bc80bd','#d9d9d9'];
const colors = ['#FF0000', '#3CEF6F', '#8F39EA', '#FFFF00', '#0059FF', '#FB8072']
const layersArray = [
  {
    id:'wsde',
    name:'Worker Self-Directed Enterprises',
  },
  {
    id:'clt',
    name:'Community Land Trusts',
  },
  {
    id:'sbdc',
    name:'Small Business Development Centers',
  },
  {
    id:'fcu',
    name:'Federal Credit Unions',
  },
  {
    id:'mutual',
    name:'Mutual Aid Groups',
  },
  {
    id:'tenant',
    name:'Tenant Unions',
  }
];

const overlaysArray = [{
  name:'Black Race',
  id: 'blackRaceOverlay',
  description: '',
  source: {
    "type": "raster",
    "url": "https://www.justicemap.org/tile/{size}/black/{z}/{x}/{y}.png"
  }
},{
  name: 'All Races',
  id: 'allRaceOverlay',
  description: '',
  source: {
    "type": "raster",
    "url": "https://demographics.virginia.edu/DotMap/tiles4/{z}/{x}/{y}.png"
  }
}];

export default class MapControlPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      layers: {
        'Worker Strikes': false,
        'Worker Self-Directed Enterprises': false,
        'Community Land Trusts': false,
        'Small Business Development Centers': false,
        'Federal Credit Unions': false,
        'Mutual Aid Groups': false,
        'Tenant Unions': false
      },
      overlay: false
    };
  }

  toggleActive = () => {
    this.props.onShowChange();
  }

  handleClick = e => {
    e.stopPropagation();
  }

  updateMapStyle = (layers, overlay) => {
    this.props.onChange(layers, overlay);
  }

  onLayersChange = (name, event) => {
    const layers = {
      ...this.state.layers,
      [name]: event.target.checked
    };
    this.setState({layers});
    this.updateMapStyle(layers, this.state.overlay);
  }

  renderLayerControl = (name, i) => {
    const {layers} = this.state;

    return (
      <div key={name} className="input">
        <label className={"layer-label " + name}>
          <input
            type="checkbox"
            checked={layers[name]}
            onChange={this.onLayersChange.bind(this, name)}
          />
          <span className="checkhole" style={{border: "1px solid " + colors[i]}}></span>
          {name}
        </label>
      </div>
    );
  }

  onOverlayChange = (name, event) => {
    const currentOverlay = this.state.overlay;
    // returns overlay name, or false if same as current
    const overlay = (currentOverlay === name) ? false : name;

    this.setState({overlay});
    this.updateMapStyle(this.state.layers, overlay);
  }

  renderOverlayControl = (name) => {
    const overlay = this.state.overlay;

    // return (
    //   <div key={name} className="input">
    //     <p onClick={this.onOverlayChange.bind(this, name)} className={ activeOverlay === name ? 'active': ''}>{name}</p>
    //   </div>
    // );

    return (
      <div key={name} className="input">
        <label className="overlay-label">
          <input
            type="checkbox"
            checked={overlay === name}
            onChange={this.onOverlayChange.bind(this, name)}
          />
          <span className="checkhole" style={{border: "1px solid #000"}}></span>
          {name}
        </label>
      </div>
    );
  }

  render() {
    const {showControl, showWorkerStrikes, toggleWorkerStrikes} = this.props;

    return (
      <div className="control-panel-holder">
        { showControl ? (
          <div className="control-panel" onClick={this.handleClick}>
            <div className="close-panel" onClick={this.toggleActive}>x</div>
            <div className="dpp-label">
              <PulsingDot size={30}></PulsingDot>
              <label style={{color: '#f00'}}>Dual Power Projects</label>
            </div>
            <div className="strikes-label" onClick={toggleWorkerStrikes}>
              { showWorkerStrikes
                ? <PulsingStrike size={30}></PulsingStrike>
                : <NonPulsingStrike />
              } 
              <label style={{color: '#f00'}}>Past Worker Strikes</label>
            </div>
            <div className="layers-control" onClick={this.handleClick}>
              { layersArray.map((layer, i) => this.renderLayerControl(layer.name, i)) }
            </div>
            <div className="overlay-control" onClick={this.handleClick}>
              { overlaysArray.map(overlay => this.renderOverlayControl(overlay.name)) }
            </div>
          </div>
        ) : (
          <div className="overlay-control-toggle" onClick={this.toggleActive}>
            <img src={require('../data/layers.png')} alt="layers icon"></img>
          </div>
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/mapControlPanel.js